import React, { useState } from 'react';
import './Steps.css';

const Step2 = ({ bookingData, updateBookingData, nextStep, prevStep }) => {
  const [lessonType, setLessonType] = useState(bookingData.lessonType || '');
  const [selectedInstructor, setSelectedInstructor] = useState(bookingData.instructorId || '');
  const [showPricing, setShowPricing] = useState(false);

  // instructors
  const allInstructors = [
    {
      id: 1,
      name: 'Mureșan Adrian',
      initials: 'MA',
      specialty: 'Lecții Schi',
      sports: ['ski']
    },
    {
      id: 2,
      name: 'Mureșan Claudia',
      initials: 'MC',
      specialty: 'Lecții Schi',
      sports: ['ski']
    },
    {
      id: 3,
      name: 'Mureșan David',
      initials: 'MD',
      specialty: 'Lecții schi & snowboard',
      sports: ['ski', 'snowboard']
    }
  ];

  // Filter instructors based on selected sport
  const instructors = allInstructors.filter(instructor => 
    instructor.sports.includes(bookingData.sport)
  );

  const handleLessonTypeSelect = (type) => {
    setLessonType(type);
    updateBookingData('lessonType', type);
  };

  const handleInstructorSelect = (instructorId) => {
    setSelectedInstructor(instructorId);
    updateBookingData('instructorId', instructorId);
    const instructor = instructors.find(i => i.id === instructorId);
    updateBookingData('instructorName', instructor.name);
  };

  const handleNext = () => {
    if (lessonType && selectedInstructor) {
      nextStep();
    }
  };

  return (
    <div className="step-container">
      <h2 className="step-heading">Tipul Lecției & Instructor</h2>
      <p className="step-description">Alegeți dacă doriți lecții individuale sau în grup și selectați instructorul preferat</p>

      {/* Lesson Type Selection */}
      <div className="lesson-type-section">
        <h3 className="subsection-title">Tipul Lecției</h3>
        <div className="lesson-type-grid">
        <button
  className={`lesson-type-card ${lessonType === 'individual' ? 'selected' : ''}`}
  onClick={() => handleLessonTypeSelect('individual')}
>
  <div className="lesson-type-icon">👤</div>
  <h4 className="lesson-type-title">Individual (Privat)</h4>
  <p className="lesson-type-desc">Lecții personalizate doar pentru tine/grupul tău</p>
  <div className="lesson-type-badge">Preț fix</div>
</button>

<button
  className={`lesson-type-card ${lessonType === 'group' ? 'selected' : ''}`}
  onClick={() => handleLessonTypeSelect('group')}
>
  <div className="lesson-type-icon">👥</div>
  <h4 className="lesson-type-title">Grup (Public)</h4>
  <p className="lesson-type-desc">Împreună cu alți participanți de nivel similar</p>
  <div className="lesson-type-badge">Preț variabil</div>
</button>
        </div>

        {lessonType === 'group' && (
          <div className="group-pricing-notice">
            <div className="notice-header">
              ⚠️ <strong>Informații importante despre lecțiile în grup:</strong>
            </div>
            <ul className="notice-list">
              <li>Tariful pentru lecțiile la grup este valabil doar pentru un minim de 3 participanți</li>
              <li>Dacă nu se formează grupa, se va aplica tariful pentru lecții individuale</li>
              <li>Prețul final depinde de numărul total de participanți care se înscriu</li>
              <li>Vă vom contacta telefonic pentru a confirma prețul exact înainte de lecție</li>
              <li><strong>Plata se face exclusiv cash la fața locului</strong></li>
            </ul>
            <button 
              className="pricing-toggle-btn"
              onClick={() => setShowPricing(!showPricing)}
            >
              {showPricing ? '▼ Ascunde tarifele' : '▶ Vezi tarifele posibile'}
            </button>
            {showPricing && (
  <div className="pricing-table">
    <h4>Tarife în funcție de numărul de participanți (RON/oră/persoană):</h4>
    <div className="pricing-row">
      <div className="pricing-label">1 persoană (individual)</div>
      <div className="pricing-value">170 RON</div>
    </div>
    <div className="pricing-row">
      <div className="pricing-label">2 persoane</div>
      <div className="pricing-value">150 RON</div>
    </div>
    <div className="pricing-row highlighted">
      <div className="pricing-label">3 persoane</div>
      <div className="pricing-value">125 RON</div>
    </div>
    <div className="pricing-row highlighted">
      <div className="pricing-label">4-6 persoane</div>
      <div className="pricing-value">105 RON</div>
    </div>
  </div>
)}
          </div>
        )}
      </div>

      {/* Instructor Selection */}
      {lessonType && (
        <div className="instructor-section">
          <h3 className="subsection-title">Selectați Instructorul</h3>
          <p className="instructor-note">
            💡 Vom încerca să alocăm instructorul dorit. În cazul în care acesta nu este disponibil, vă vom contacta pentru a propune o alternativă.
          </p>
          <div className="instructors-grid">
            {instructors.map(instructor => (
              <div
                key={instructor.id}
                className={`instructor-card ${selectedInstructor === instructor.id ? 'selected' : ''}`}
                onClick={() => handleInstructorSelect(instructor.id)}
              >
                <div className="instructor-avatar-circle">
                  {instructor.initials}
                </div>
                <h4 className="instructor-name">{instructor.name}</h4>
                <div className="instructor-specialty">{instructor.specialty}</div>
                {selectedInstructor === instructor.id && (
                  <div className="instructor-selected-badge">✓ Selectat</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="step-actions">
        <button className="btn-secondary" onClick={prevStep}>
          ← Înapoi
        </button>
        <button 
          className="btn-primary"
          onClick={handleNext}
          disabled={!lessonType || !selectedInstructor}
        >
          Continuă →
        </button>
      </div>
    </div>
  );
};

export default Step2;